import { downloadFile } from '../../../utils/common';

// Baja el archivo de una URL firmada de S3 con el nombre indicado
export const descargarDesdeUrl = async (url: string, nombre: string): Promise<void> => {
    const fileResponse = await fetch(url);
    const blob = await fileResponse.blob();
    downloadFile({ blob, name: nombre });
};
